export class TurnReportBasic {

    private appTurnsCancelled: number;
    private appTurnsPicked: number;
    private centerName: string;
    private centerInternalId: string;
    private creationDate: number;
    private internalId: string;
    private modificationDate: number;
    private smsTurnsPicked: number;
    private ticketTurnsPicked: number;
    private totalTurnsAttended: number;
    private totalTurnsBacked: number;
    private totalTurnsCancelled: number;
    private totalTurnsPassed: number;
    private totalTurnsPicked: number;
    private turnDeskInternalId: string;
    private turnDeskName: string;
    private turnDeskStatus: string;
    private turnsDate: number;
    private turnsWaitAverageSecs: number;
    private turnsWaitAverageSecsSum: number;

    constructor(appTurnsCancelled?: number,
        appTurnsPicked?: number,
        centerName?: string,
        centerInternalId?: string,
        creationDate?: number,
        internalId?: string,
        modificationDate?: number,
        smsTurnsPicked?: number,
        ticketTurnsPicked?: number,
        totalTurnsAttended?: number,
        totalTurnsBacked?: number,
        totalTurnsCancelled?: number,
        totalTurnsPassed?: number,
        totalTurnsPicked?: number,
        turnDeskInternalId?: string,
        turnDeskName?: string,
        turnDeskStatus?: string,
        turnsDate?: number,
        turnsWaitAverageSecs?: number,
        turnsWaitAverageSecsSum?: number) {
            this.appTurnsCancelled = appTurnsCancelled;
            this.appTurnsPicked = appTurnsPicked;
            this.centerName = centerName;
            this.centerInternalId = centerInternalId;
            this.creationDate = creationDate;
            this.internalId = internalId;
            this.modificationDate = modificationDate;
            this.smsTurnsPicked = smsTurnsPicked;
            this.ticketTurnsPicked = ticketTurnsPicked;
            this.totalTurnsAttended = totalTurnsAttended;
            this.totalTurnsBacked = totalTurnsBacked;
            this.totalTurnsCancelled = totalTurnsCancelled;
            this.totalTurnsPassed = totalTurnsPassed;
            this.totalTurnsPicked = totalTurnsPicked;
            this.turnDeskInternalId = turnDeskInternalId;
            this.turnDeskName = turnDeskName;
            this.turnDeskStatus = turnDeskStatus;
            this.turnsDate = turnsDate;
            this.turnsWaitAverageSecs = turnsWaitAverageSecs;
            this.turnsWaitAverageSecsSum = turnsWaitAverageSecsSum;

    }

    public get AppTurnsCancelled() {
        return this.appTurnsCancelled;
    }
    public get AppTurnsPicked() {
        return this.appTurnsPicked;
    }
    public get CenterName() {
        return this.centerName;
    }
    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get CreationDate() {
        return this.creationDate;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get ModificationDate() {
        return this.modificationDate;
    }
    public get SmsTurnsPicked() {
        return this.smsTurnsPicked;
    }
    public get TicketTurnsPicked() {
        return this.ticketTurnsPicked;
    }
    public get TotalTurnsAttended() {
        return this.totalTurnsAttended;
    }
    public get TotalTurnsBacked() {
        return this.totalTurnsBacked;
    }
    public get TotalTurnsCancelled() {
        return this.totalTurnsCancelled;
    }
    public get TotalTurnsPassed() {
        return this.totalTurnsPassed;
    }
    public get TotalTurnsPicked() {
        return this.totalTurnsPicked;
    }
    public get TurnDeskInternalId() {
        return this.turnDeskInternalId;
    }
    public get TurnDeskName() {
        return this.turnDeskName;
    }
    public get TurnDeskStatus() {
        return this.turnDeskStatus;
    }
    public get TurnsDate() {
        return this.turnsDate;
    }
    public get TurnsWaitAverageSecs() {
        return this.turnsWaitAverageSecs;
    }
    public get TurnsWaitAverageSecsSum() {
        return this.turnsWaitAverageSecsSum;
    }

    public set AppTurnsCancelled(appTurnsCancelled) {
        this.appTurnsCancelled = appTurnsCancelled;
    }
    public set AppTurnsPicked(appTurnsPicked) {
        this.appTurnsPicked = appTurnsPicked;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set CreationDate(creationDate) {
        this.creationDate = creationDate;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set ModificationDate(modificationDate) {
        this.modificationDate = modificationDate;
    }
    public set SmsTurnsPicked(smsTurnsPicked) {
        this.smsTurnsPicked = smsTurnsPicked;
    }
    public set TicketTurnsPicked(ticketTurnsPicked) {
        this.ticketTurnsPicked = ticketTurnsPicked;
    }
    public set TotalTurnsAttended(totalTurnsAttended) {
        this.totalTurnsAttended = totalTurnsAttended;
    }
    public set TotalTurnsBacked(totalTurnsBacked) {
        this.totalTurnsBacked = totalTurnsBacked;
    }
    public set TotalTurnsCancelled(totalTurnsCancelled) {
        this.totalTurnsCancelled = totalTurnsCancelled;
    }
    public set TotalTurnsPassed(totalTurnsPassed) {
        this.totalTurnsPassed = totalTurnsPassed;
    }
    public set TotalTurnsPicked(totalTurnsPicked) {
        this.totalTurnsPicked = totalTurnsPicked;
    }
    public set TurnDeskInternalId(turnDeskInternalId) {
        this.turnDeskInternalId = turnDeskInternalId;
    }
    public set TurnDeskName(turnDeskName) {
        this.turnDeskName = turnDeskName;
    }
    public set TurnDeskStatus(turnDeskStatus) {
        this.turnDeskStatus = turnDeskStatus;
    }
    public set TurnsDate(turnsDate) {
        this.turnsDate = turnsDate;
    }
    public set TurnsWaitAverageSecs(turnsWaitAverageSecs) {
        this.turnsWaitAverageSecs = turnsWaitAverageSecs;
    }
    public set TurnsWaitAverageSecsSum(turnsWaitAverageSecsSum) {
        this.turnsWaitAverageSecsSum = turnsWaitAverageSecsSum;
    }
}
